import { Alert } from '../interfaces/alert'

const WarningComponent: React.FC<{ message: string; type: Alert }> = ({ message, type }) => (
  <div style={{ border: `1px solid #${type.borderColor}`, backgroundColor: `#${type.backgroundColor}`, borderRadius: '10px', padding: type.customPadding ?? '10px', margin: type.customMargin ?? '-10px 20px 20px' }}>
    <h1 style={{ fontSize: '0.85em', fontWeight: '600', color: `#${type.fontColor}`, margin: '0', lineHeight: 'unset' }}>{ message }</h1>
  </div>
)

export default WarningComponent